import { withRouter } from 'react-router'

import { clearAllStorage } from '../../core/helpers/AuthHelpers'

const Logout = () => {
  clearAllStorage()
}

export default withRouter(Logout)
